// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3o5gk1","iconContainer":"uEB8QC","iconContainerCompleted":"AbXfQo","icon":"_34FYvG","preTitle":"_132FTP"};